const initialState = {
	pathname: '/',
	search: '',
	hash: '',
};
export default (state = initialState, action) => {
	switch (action.type) {
		case 'LOCATION_CHANGE':
			return {
				...state,
				...action.payload,
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/locationChange.js